const AE = require('./countries/AE');
const AL = require('./countries/AL');
const AR = require('./countries/AR');
const AT = require('./countries/AT');
const AU = require('./countries/AU');
const BE = require('./countries/BE');
const BG = require('./countries/BG');
const BM = require('./countries/BM');
const BN = require('./countries/BN');
const BO = require('./countries/BO');
const BR = require('./countries/BR');
const BS = require('./countries/BS');
const BY = require('./countries/BY');
const BZ = require('./countries/BZ');
const CA = require('./countries/CA');
const CH = require('./countries/CH');
const CL = require('./countries/CL');
const CN = require('./countries/CN');
const CO = require('./countries/CO');
const CR = require('./countries/CR');
const CY = require('./countries/CY');
const CZ = require('./countries/CZ');
const DE = require('./countries/DE');
const DK = require('./countries/DK');
const DO = require('./countries/DO');
const EE = require('./countries/EE');
const ES = require('./countries/ES');
const FI = require('./countries/FI');
const FR = require('./countries/FR');
const GA = require('./countries/GA');
const GB = require('./countries/GB');
const GE = require('./countries/GE');
const GR = require('./countries/GR');
const GT = require('./countries/GT');
const GU = require('./countries/GU');
const HK = require('./countries/HK');
const HN = require('./countries/HN');
const HR = require('./countries/HR');
const HU = require('./countries/HU');
const ID = require('./countries/ID');
const IE = require('./countries/IE');
const IL = require('./countries/IL');
const IN = require('./countries/IN');
const IS = require('./countries/IS');
const IT = require('./countries/IT');
const JP = require('./countries/JP');
const KE = require('./countries/KE');
const KH = require('./countries/KH');
const KR = require('./countries/KR');
const KW = require('./countries/KW');
const KY = require('./countries/KY');
const LB = require('./countries/LB');
const LI = require('./countries/LI');
const LT = require('./countries/LT');
const LU = require('./countries/LU');
const LV = require('./countries/LV');
const MA = require('./countries/MA');
const MC = require('./countries/MC');
const MD = require('./countries/MD');
const ME = require('./countries/ME');
const MG = require('./countries/MG');
const MM = require('./countries/MM');
const MR = require('./countries/MR');
const MT = require('./countries/MT');
const MX = require('./countries/MX');
const MY = require('./countries/MY');
const NC = require('./countries/NC');
const NL = require('./countries/NL');
const NO = require('./countries/NO');
const NZ = require('./countries/NZ');
const PA = require('./countries/PA');
const PE = require('./countries/PE');
const PF = require('./countries/PF');
const PH = require('./countries/PH');
const PL = require('./countries/PL');
const PR = require('./countries/PR');
const PT = require('./countries/PT');
const PY = require('./countries/PY');
const RO = require('./countries/RO');
const RS = require('./countries/RS');
const RU = require('./countries/RU');
const SA = require('./countries/SA');
const SD = require('./countries/SD');
const SE = require('./countries/SE');
const SG = require('./countries/SG');
const SI = require('./countries/SI');
const SK = require('./countries/SK');
const SN = require('./countries/SN');
const SV = require('./countries/SV');
const SZ = require('./countries/SZ');
const TH = require('./countries/TH');
const TR = require('./countries/TR');
const TW = require('./countries/TW');
const US = require('./countries/US');
const ZA = require('./countries/ZA');

exports.countryDefinitions = {
  AE: AE.countryDefinition,
  AL: AL.countryDefinition,
  AR: AR.countryDefinition,
  AT: AT.countryDefinition,
  AU: AU.countryDefinition,
  BE: BE.countryDefinition,
  BG: BG.countryDefinition,
  BM: BM.countryDefinition,
  BN: BN.countryDefinition,
  BO: BO.countryDefinition,
  BR: BR.countryDefinition,
  BS: BS.countryDefinition,
  BY: BY.countryDefinition,
  BZ: BZ.countryDefinition,
  CA: CA.countryDefinition,
  CH: CH.countryDefinition,
  CL: CL.countryDefinition,
  CN: CN.countryDefinition,
  CO: CO.countryDefinition,
  CR: CR.countryDefinition,
  CY: CY.countryDefinition,
  CZ: CZ.countryDefinition,
  DE: DE.countryDefinition,
  DO: DO.countryDefinition,
  DK: DK.countryDefinition,
  EE: EE.countryDefinition,
  ES: ES.countryDefinition,
  FI: FI.countryDefinition,
  FR: FR.countryDefinition,
  GA: GA.countryDefinition,
  GB: GB.countryDefinition,
  GE: GE.countryDefinition,
  GR: GR.countryDefinition,
  GU: GU.countryDefinition,
  GT: GT.countryDefinition,
  HN: HN.countryDefinition,
  HK: HK.countryDefinition,
  HR: HR.countryDefinition,
  HU: HU.countryDefinition,
  ID: ID.countryDefinition,
  IE: IE.countryDefinition,
  IL: IL.countryDefinition,
  IN: IN.countryDefinition,
  IS: IS.countryDefinition,
  IT: IT.countryDefinition,
  JP: JP.countryDefinition,
  KE: KE.countryDefinition,
  KH: KH.countryDefinition,
  KR: KR.countryDefinition,
  KW: KW.countryDefinition,
  KY: KY.countryDefinition,
  LB: LB.countryDefinition,
  LI: LI.countryDefinition,
  LT: LT.countryDefinition,
  LU: LU.countryDefinition,
  LV: LV.countryDefinition,
  MA: MA.countryDefinition,
  MC: MC.countryDefinition,
  MD: MD.countryDefinition,
  ME: ME.countryDefinition,
  MG: MG.countryDefinition,
  MM: MM.countryDefinition,
  MR: MR.countryDefinition,
  MT: MT.countryDefinition,
  MX: MX.countryDefinition,
  MY: MY.countryDefinition,
  NC: NC.countryDefinition,
  NO: NO.countryDefinition,
  NL: NL.countryDefinition,
  NZ: NZ.countryDefinition,
  PA: PA.countryDefinition,
  PE: PE.countryDefinition,
  PF: PF.countryDefinition,
  PH: PH.countryDefinition,
  PL: PL.countryDefinition,
  PR: PR.countryDefinition,
  PT: PT.countryDefinition,
  PY: PY.countryDefinition,
  RO: RO.countryDefinition,
  RS: RS.countryDefinition,
  RU: RU.countryDefinition,
  SA: SA.countryDefinition,
  SD: SD.countryDefinition,
  SE: SE.countryDefinition,
  SG: SG.countryDefinition,
  SI: SI.countryDefinition,
  SK: SK.countryDefinition,
  SN: SN.countryDefinition,
  SV: SV.countryDefinition,
  SZ: SZ.countryDefinition,
  TH: TH.countryDefinition,
  TR: TR.countryDefinition,
  TW: TW.countryDefinition,
  US: US.countryDefinition,
  ZA: ZA.countryDefinition
};
exports.countryName = (countryCode) => {
  if (exports.countryDefinitions[countryCode]) {
    return exports.countryDefinitions[countryCode].country;
  }
  return countryCode;
};

exports.stateName = (countryCode, stateCode) => {
  if (
    exports.countryDefinitions[countryCode] &&
    exports.countryDefinitions[countryCode].states &&
    exports.countryDefinitions[countryCode].states[stateCode]
  ) {
    return exports.countryDefinitions[countryCode].states[stateCode];
  }
  return stateCode;
};

exports.validateFormInput = (address) => {
  const errorArray = [];

  if (!address || !address.countryCode) {
    errorArray.push({
      field: 'countryCode',
      message: 'required'
    });
    return errorArray;
  }

  if (
    !exports.countryDefinitions[address.countryCode] ||
    !exports.countryDefinitions[address.countryCode].requiredFormFields
  ) {
    errorArray.push({
      field: 'countryCode',
      message: 'invalid country code'
    });
    return errorArray;
  }

  const requiredFields =
    exports.countryDefinitions[address.countryCode].requiredFormFields;

  if (!requiredFields) {
    return errorArray;
  }

  requiredFields.forEach((field) => {
    const currentField = address[field.field];
    if (
      currentField === undefined ||
      currentField === '' ||
      currentField === null
    ) {
      errorArray.push({
        field: field.field,
        translatedField:
          exports.countryDefinitions[address.countryCode].schema[field.field]
            .label,
        message: 'required'
      });
    }
    if (
      field.validationRegex &&
      currentField &&
      !field.validationRegex.test(currentField)
    ) {
      errorArray.push({
        field: field.field,
        translatedField:
          exports.countryDefinitions[address.countryCode].schema[field.field]
            .label,
        message: field.error
      });
    }
  });
  return errorArray;
};

exports.zipCodeFormat = (zipCode, countryCode) => {
  if (!zipCode) {
    return null;
  }

  switch (countryCode) {
    case 'AE':
    case 'GA':
      return null;
    case 'BM':
      return BM.zipCodeNormalize(zipCode);
    case 'BN':
      return BN.zipCodeNormalize(zipCode);
    case 'BO':
      return BO.zipCodeNormalize(zipCode);
    case 'BR':
      return BR.zipCodeNormalize(zipCode);
    case 'CA':
      return CA.zipCodeNormalize(zipCode);
    case 'CL':
      return CL.zipCodeNormalize(zipCode);
    case 'CO':
      return CO.zipCodeNormalize(zipCode);
    case 'CR':
      return CR.zipCodeNormalize(zipCode);
    case 'CZ':
      return CZ.zipCodeNormalize(zipCode);
    case 'ES':
      return ES.zipCodeNormalize(zipCode);
    case 'GB':
      return GB.zipCodeNormalize(zipCode);
    case 'GE':
      return GE.zipCodeNormalize(zipCode);
    case 'GR':
      return GR.zipCodeNormalize(zipCode);
    case 'GT':
      return GT.zipCodeNormalize(zipCode);
    case 'GU':
      return GU.zipCodeNormalize(zipCode);
    case 'HR':
      return HR.zipCodeNormalize(zipCode);
    case 'IE':
      return IE.zipCodeNormalize(zipCode);
    case 'JP':
      return JP.zipCodeNormalize(zipCode);
    case 'KR':
      return KR.zipCodeNormalize(zipCode);
    case 'LB':
      return LB.zipCodeNormalize(zipCode);
    case 'LT':
      return LT.zipCodeNormalize(zipCode);
    case 'MT':
      return MT.zipCodeNormalize(zipCode);
    case 'NC':
      return NC.zipCodeNormalize(zipCode);
    case 'NL':
      return NL.zipCodeNormalize(zipCode);
    case 'NO':
      return NO.zipCodeNormalize(zipCode);
    case 'PE':
      return PE.zipCodeNormalize(zipCode);
    case 'PL':
      return PL.zipCodeNormalize(zipCode);
    case 'PF':
      return PF.zipCodeNormalize(zipCode);
    case 'PR':
      return PR.zipCodeNormalize(zipCode);
    case 'PY':
      return PY.zipCodeNormalize(zipCode);
    case 'PT':
      return PT.zipCodeNormalize(zipCode);
    case 'RS':
      return RS.zipCodeNormalize(zipCode);
    case 'SA':
      return SA.zipCodeNormalize(zipCode);
    case 'SD':
      return SD.zipCodeNormalize(zipCode);
    case 'SE':
      return SE.zipCodeNormalize(zipCode);
    case 'SK':
      return SK.zipCodeNormalize(zipCode);
    case 'SN':
      return SN.zipCodeNormalize(zipCode);
    case 'SZ':
      return SZ.zipCodeNormalize(zipCode);
    case 'TR':
      return TR.zipCodeNormalize(zipCode);
    case 'TW':
      return TW.zipCodeNormalize(zipCode);
    case 'SV':
      return SV.zipCodeNormalize(zipCode);
    case 'ZA':
      return ZA.zipCodeNormalize(zipCode);
    case 'AL':
    case 'AR':
    case 'AU':
    case 'AT':
    case 'BE':
    case 'BG':
    case 'BS':
    case 'BY':
    case 'BZ':
    case 'CH':
    case 'CN':
    case 'CY':
    case 'DE':
    case 'DO':
    case 'DK':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'HN':
    case 'HU':
    case 'ID':
    case 'IL':
    case 'IN':
    case 'IS':
    case 'IT':
    case 'KE':
    case 'KH':
    case 'KY':
    case 'KW':
    case 'LI':
    case 'LU':
    case 'LV':
    case 'MA':
    case 'MC':
    case 'MD':
    case 'ME':
    case 'MG':
    case 'MM':
    case 'MR':
    case 'MX':
    case 'MY':
    case 'NZ':
    case 'PA':
    case 'PH':
    case 'RO':
    case 'RU':
    case 'SG':
    case 'SI':
    case 'TH':
    case 'US':
      return zipCode;
    default:
      return null;
  }
};

exports.zipCodeNormalize = (zipCode, countryCode) => {
  if (!zipCode) {
    return null;
  }

  switch (countryCode) {
    case 'AE':
    case 'BN':
    case 'GA':
    case 'PA':
      return null;
    case 'AR':
    case 'BM':
    case 'CA':
    case 'GB':
    case 'IE':
    case 'HN':
    case 'LB':
    case 'NL':
    case 'SV':
      return zipCode.replace(/[^\w]/g, '');
    case 'BR':
      return BR.zipCodeNormalize(zipCode);
    case 'CR':
      return CR.zipCodeNormalize(zipCode);
    case 'ES':
      return ES.zipCodeNormalize(zipCode);
    case 'HR':
      return HR.zipCodeNormalize(zipCode);
    case 'LT':
      return LT.zipCodeNormalize(zipCode);
    case 'LV':
      return LV.zipCodeNormalize(zipCode);
    case 'MD':
      return MD.zipCodeNormalize(zipCode);
    case 'KR':
      return KR.zipCodeNormalize(zipCode);
    case 'KY':
      return KY.zipCodeNormalize(zipCode);
    case 'NC':
      return NC.zipCodeNormalize(zipCode);
    case 'NO':
      return NO.zipCodeNormalize(zipCode);
    case 'PE':
      return PE.zipCodeNormalize(zipCode);
    case 'PL':
      return PL.zipCodeNormalize(zipCode);
    case 'PY':
      return PY.zipCodeNormalize(zipCode);
    case 'RS':
      return RS.zipCodeNormalize(zipCode);
    case 'SA':
      return SA.zipCodeNormalize(zipCode);
    case 'SN':
      return SN.zipCodeNormalize(zipCode);
    case 'PF':
      return PF.zipCodeNormalize(zipCode);
    case 'SD':
      return SD.zipCodeNormalize(zipCode);
    case 'SE':
      return SE.zipCodeNormalize(zipCode);
    case 'SZ':
      return SZ.zipCodeNormalize(zipCode);
    case 'TR':
      return TR.zipCodeNormalize(zipCode);
    case 'US':
      return US.zipCodeNormalize(zipCode);
    case 'ZA':
      return ZA.zipCodeNormalize(zipCode);
    case 'CH':
    case 'CL':
    case 'CN':
    case 'CO':
    case 'AL':
    case 'BS':
    case 'BY':
    case 'BZ':
    case 'CY':
    case 'CZ':
    case 'DO':
    case 'DK':
    case 'GR':
    case 'TW':
    case 'AU':
    case 'AT':
    case 'BE':
    case 'BG':
    case 'BO':
    case 'DE':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'GE':
    case 'GT':
    case 'GU':
    case 'HU':
    case 'ID':
    case 'IL':
    case 'IN':
    case 'IS':
    case 'IT':
    case 'JP':
    case 'KE':
    case 'KH':
    case 'KW':
    case 'LI':
    case 'LU':
    case 'MA':
    case 'MC':
    case 'ME':
    case 'MG':
    case 'MM':
    case 'MR':
    case 'MX':
    case 'MY':
    case 'NZ':
    case 'PH':
    case 'PR':
    case 'PT':
    case 'RO':
    case 'RU':
    case 'SG':
    case 'SI':
    case 'SK':
    case 'TH':
      return zipCode.replace(/[^\d]/g, '');
    default:
      return null;
  }
};
